export default "__VITE_ASSET__CY1Awkb8__"